// Generated automatically by the "generate" script
export const cssPostfix = '611444a';
//# sourceMappingURL=cssPostfix.mjs.mjs.map